import React from 'react';
import { Toaster } from 'react-hot-toast';

import ThankYou from '../ThankYou';
import BackToTop from '../BackToTop';
import ThemeToggle from '../ThemeToggle';
import ProgressIndicator from '../ProgressIndicator';
import SeasonalEffects from '../SeasonalEffects';
import {
  shouldRenderOnPage,
  type PublicSiteShellSettings,
} from '../../hooks/usePublicSiteShellSettings';

type PublicSiteChromeProps = {
  pageKey: string;
  shellSettings: PublicSiteShellSettings;
  showThankYou: boolean;
  onCloseThankYou: () => void;
  suppressProgress?: boolean;
};

const PublicSiteChrome: React.FC<PublicSiteChromeProps> = ({
  pageKey,
  shellSettings,
  showThankYou,
  onCloseThankYou,
  suppressProgress = false,
}) => {
  const themeTogglePositionClass =
    shellSettings.themeTogglePosition === 'top-left' ? 'left-4 top-4' : 'right-4 top-4';

  return (
    <>
      <Toaster position="top-center" />
      {shellSettings.showSeasonalEffects &&
      shouldRenderOnPage(pageKey, shellSettings.seasonalEffectsPageKeys) ? (
        <SeasonalEffects />
      ) : null}
      {shellSettings.showProgressIndicator &&
      !suppressProgress &&
      shouldRenderOnPage(pageKey, shellSettings.progressIndicatorPageKeys) ? (
        <ProgressIndicator steps={shellSettings.progressIndicatorSteps} />
      ) : null}
      {shellSettings.showThemeToggle &&
      shouldRenderOnPage(pageKey, shellSettings.themeTogglePageKeys) ? (
        <div className={`fixed z-50 ${themeTogglePositionClass}`}>
          <ThemeToggle />
        </div>
      ) : null}
      {shellSettings.showThankYouOverlay ? (
        <ThankYou
          visible={showThankYou}
          onClose={onCloseThankYou}
          title={shellSettings.thankYouTitle}
          message={shellSettings.thankYouMessage}
          buttonLabel={shellSettings.thankYouButtonLabel}
        />
      ) : null}
      {shellSettings.showBackToTop &&
      shouldRenderOnPage(pageKey, shellSettings.backToTopPageKeys) ? (
        <BackToTop position={shellSettings.backToTopPosition} />
      ) : null}
    </>
  );
};

export default PublicSiteChrome;
